// RedirectWithConfirm.jsx
import React from 'react'

const RedirectWithConfirm = ({ show, url, onCancel, onConfirm }) => {
  if (!show) return null

  return (
    <div className='modal-backdrop-custom'>
      <div className='modal-box p-4 bg-white rounded shadow text-black'>
        <h5>Redirect Confirmation</h5>
        <p>
          You are being redirected to <br />
          <span className='text-success fw-bold'>{url}</span>
          <br />
          Do you want to continue?
        </p>
        <div className='d-flex justify-content-end gap-2'>
          <button className='btn btn-secondary' onClick={onCancel}>
            Cancel
          </button>
          <button className='btn btn-success' onClick={onConfirm}>
            Yes, Continue
          </button>
        </div>
      </div>
    </div>
  )
}

export default RedirectWithConfirm
